import EmployeeProfileContainer from "../../../Components/Workforce/EmployeeProfile";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import { CRUDPermissions } from "../../../Types/Common/Access";
import { useLocation } from "react-router-dom";

const EmployeeProfile = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Employee Profile";
  }, []);

  const routerLocation = useLocation();
  const access = routerLocation.state?.access as CRUDPermissions;

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "recruiter"]}
      />

      {/* Main content */}
      <EmployeeProfileContainer access={access} />
    </>
  );
};

export default EmployeeProfile;
